const initialState = true;

const testReducers = (state = initialState, action) => {
    switch (action.type) {
        case "changeLoadTrue": return true;
        case "changeLoadFalse": return false;
        default: return state;
    }
}
export default testReducers;